import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { LockedTimeVertex } from '../interfaces/vertices/locked-times';

export default (
  lockedTimes: Types.Mixed.LockedTime[],
  options:     BaseOptions
): OutTypes.lockedTime[] => {
  return lockedTimes
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<LockedTimeVertex> = {
        coalesced: x.coalesced?.map(x => ({ toModel: x.toModel, to: getVertexId(x.to, options) })),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<LockedTimeVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
